export const classesConstants = {
  GET_CLASSES: "GET_CLASSES",
  GET_CLASSE: "GET_CLASSE",
  GET_ETUDIANTS: "GET_ETUDIANTS",
  GET_SEARCH_ETUDIANTS: "GET_SEARCH_ETUDIANTS",
};
